import { Dayjs } from 'dayjs'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { UseGetOptionReturn } from './index.hook'

export interface FormValues {
  transactionType: number
  clientIds: string[]
  accountIds: string[]
  dateType?: number
  date?: Array<Dayjs> | Array<string>
  amountFrom?: string
  amountTo?: string
  decisionId?: string
  reasonId?: string[]
  paidDate?: Array<Dayjs> | Array<string>
  secCode?: string
  checkStatuses?: string[]
  issuedPayee?: string
  checkNumberFrom?: string
  checkNumberTo?: string
}

export interface IOption {
  label: string
  value: any
}

export interface AllTransactionContextProps {
  form: UseFormReturn<FormValues>
  options: UseGetOptionReturn
  loading: boolean
  gettingData: boolean
  disabled: boolean
  hasRestoredFilters: boolean
  onSubmit: (values: FormValues) => Promise<any>
  onReset: () => void
}

export const AllTransactionContext = React.createContext<AllTransactionContextProps>({
  form: null as any,
  options: {} as any,
  loading: false,
  gettingData: false,
  disabled: false,
  hasRestoredFilters: false,
  onSubmit: () => Promise.resolve({}),
  onReset: () => {},
})

export const useAllTransactionContext = () => React.useContext(AllTransactionContext)
